import { render } from "./FormworkDialog.vue?vue&type=template&id=c8cc51d4"
import script from "./FormworkDialog.vue?vue&type=script&lang=js"
export * from "./FormworkDialog.vue?vue&type=script&lang=js"

import "./FormworkDialog.vue?vue&type=style&index=0&id=c8cc51d4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__